module.exports = __webpack_public_path__ + "img/notice1.50e94711.png";